import PageHeader from "@/components/PageHeader";
import Reveal from "@/components/Reveal";
import { ButtonSecondary } from "@/components/Buttons";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

const FAQS = [
    {
        question: "What is Grayhaven Research?",
        answer: "Grayhaven Research is a professional research materials company. We supply carefully sourced, independently tested materials for laboratory research, with a standing commitment to quality, transparency, documentation and scientific integrity.",
    },
    {
        question: "What does independent testing mean?",
        answer: "It means verification is performed by third-party laboratories that are independent of Grayhaven Research. The laboratory has no stake in the outcome — the results you see reflect the material as tested, not our preference.",
    },
    {
        question: "What documentation is provided?",
        answer: "Documentation includes Certificates of Analysis for the relevant batch, plus batch and lot records where applicable. Documentation for any material we supply is available on request, and our online COA library is being prepared for direct access.",
    },
    {
        question: "What are Certificates of Analysis?",
        answer: "A Certificate of Analysis (COA) is the laboratory record for a specific batch of material. It identifies the material and batch or lot, records the analytical methods used and the laboratory that performed them, and reports the results as measured — including purity verification.",
    },
    {
        question: "How does Grayhaven approach quality control?",
        answer: "Through defined standards at every step: suppliers are vetted before materials are considered, sourcing is deliberate and documented, testing is independent, and materials are released only when they meet our criteria. Records are retained so every claim can be traced back to evidence.",
    },
    {
        question: "What does “research use only” mean?",
        answer: "It means our materials are supplied strictly for laboratory research purposes. They are not intended for human or veterinary use, and nothing we publish should be read as medical advice, dosing guidance, or a therapeutic claim.",
    },
    {
        question: "How do I request documentation for a material?",
        answer: "Contact us at hello@grayhavenresearch.com or through the contact form, noting the material and, where applicable, the batch or lot number. We will respond with the relevant documentation.",
    },
];

export default function FAQ() {
    return (
        <div data-testid="faq-page">
            <PageHeader
                eyebrow="Questions"
                title="Frequently Asked Questions"
                description="Direct answers about who we are, how we work, and what our documentation means."
            />

            <section className="pb-24 sm:pb-32 px-6 lg:px-8">
                <Reveal className="max-w-3xl mx-auto">
                    <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
                        {FAQS.map((faq, i) => (
                            <AccordionItem
                                key={faq.question}
                                value={`item-${i}`}
                                className="border-b border-stone-200"
                            >
                                <AccordionTrigger
                                    data-testid={`faq-question-${i}`}
                                    className="py-6 text-left font-serif text-xl sm:text-2xl font-light text-brand hover:text-wine hover:no-underline transition-colors duration-300 [&>svg]:text-gold"
                                >
                                    {faq.question}
                                </AccordionTrigger>
                                <AccordionContent
                                    data-testid={`faq-answer-${i}`}
                                    className="text-sm leading-relaxed text-mist pb-6"
                                >
                                    {faq.answer}
                                </AccordionContent>
                            </AccordionItem>
                        ))}
                    </Accordion>

                    <div className="mt-16 text-center border border-stone-200 bg-white rounded-sm px-8 py-12">
                        <h2 className="font-serif text-2xl sm:text-3xl font-light text-brand">
                            A question we have not answered?
                        </h2>
                        <p className="mt-4 text-sm leading-relaxed text-mist">
                            We would rather answer a question directly than leave it open.
                        </p>
                        <div className="mt-8">
                            <ButtonSecondary to="/contact" data-testid="faq-contact-btn">
                                Contact Grayhaven
                            </ButtonSecondary>
                        </div>
                    </div>
                </Reveal>
            </section>
        </div>
    );
}
